import { render, staticRenderFns } from "./choose-answer-option.vue?vue&type=template&id=159c6ebd&scoped=true&"
import script from "./choose-answer-option.vue?vue&type=script&lang=js&"
export * from "./choose-answer-option.vue?vue&type=script&lang=js&"
import style0 from "./choose-answer-option.vue?vue&type=style&index=0&id=159c6ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c6ebd",
  null
  
)

export default component.exports